var uv1VS = `
vec2 getUv1() {
		return vertex_texCoord1;
}
`;

export { uv1VS as default };
